export default "/images/3cc3701cb5c8c9b68accabf933cf5944.avif";